import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, Stack } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { FormattedMessage } from 'react-intl';

const UserBlock = ({ user, onRowClick, onDeleteClick }) => {
  return (
    <Grid item xs={12} key={user.id} onClick={(event) => onRowClick(event, user)}>
      <div style={{ border: '1px solid #ccc', padding: '10px' }}>
        <p><FormattedMessage id='user.form.label.firstname' defaultMessage='First name' /> : {user.name}</p>
        <p><FormattedMessage id='user.form.label.lastname' defaultMessage='Last name' /> : {user.surname}</p>
        <p><FormattedMessage id='user.form.label.emailAddress' defaultMessage='Email address' /> : {user.email}</p>
        <p><FormattedMessage id='user.form.label.role' defaultMessage='Role' /> : {user.role}</p>
        <p><FormattedMessage id='user.form.label.active' defaultMessage='Active' /> : {user.active ? <CheckIcon /> : <CloseIcon />}</p>
        <Stack direction="row" alignItems="center" justifyContent="center" mt={2}>
          <Button variant="contained" startIcon={<DeleteIcon />} onClick={() => onDeleteClick(user)}>
            <FormattedMessage id='users.tooltip.removeUser' defaultMessage='Remove User' /> 
          </Button>
        </Stack>
      </div>
    </Grid>
  );
};

UserBlock.propTypes = {
  user: PropTypes.object.isRequired,
  onRowClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
};

export { UserBlock };